module.exports = __webpack_public_path__ + "3476e8b7a74f45e304e17f1038a77a5f.jpg";